<template>
  <div>
    <div class="card custom-card">
      <div class="card-body pt-3 pl-3 pr-3 pb-0">
        <form>
          <div class="form-row">
            <div class="form-group col-md-4 pr-15">
              <label for="inputEmail4" class="custom-form-title">METRIC</label>
              <select class="form-control form-control-sm" disabled>
                <option selected>People vaccinated</option>
                <option value="1">Confirmed cases</option>
                <option value="2">Reproduction rate</option>
                <option value="3">Confirmed deaths</option>
              </select>
            </div>
            <div class="form-group col-md-4 pr-15">
              <label for="inputPassword4" class="custom-form-title">
                INTERVAL
              </label>
              <select class="form-control form-control-sm" disabled>
                <option selected>Cumulative</option>
              </select>
            </div>
            <div class="form-group col-md-2">
              <label for="inputPassword4">&nbsp;</label>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="gridCheck1"
                  checked
                />
                <label class="form-check-label" for="gridCheck1">
                  Relative to Population
                </label>
              </div>
            </div>
            <div class="form-group col-md-2">
              <label for="inputPassword4">&nbsp;</label>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="gridCheck1"
                  disabled
                />
                <label class="form-check-label" for="gridCheck1">
                  Align outbreaks
                </label>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.custom-form-title {
  font-size: 11px;
  color: #7a899e;
  font-weight: 400;
}
.form-check-label h5 {
  font-size: 15px;
}
</style>
